import { slugify } from "./slug";

export interface CategoryPath {
	superSlug: string;
	categorySlug?: string;
}

const DIGIT = /\d/;

// No category may use this code: /shop/<super>/all is the super category's Shop All page.
export const SHOP_ALL_SLUG = "all";

// A sku always carries a digit and a category code never does; F5 routes on the same rule.
export function parseCategoryPath(
	segments: readonly string[] | undefined
): CategoryPath | null {
	if (!segments || segments.length === 0 || segments.length > 2) {
		return null;
	}

	const slugs = segments.map(slugify);
	if (slugs.some((slug) => !slug || DIGIT.test(slug))) {
		return null;
	}

	const [superSlug, categorySlug] = slugs;
	return { superSlug, categorySlug };
}

// 308 once F5 serves these pages to everyone: until then a browser would replay it onto Hybris.
export const CATEGORY_REDIRECT_STATUS: 307 | 308 = 307;

export const CATEGORY_PATH_SEPARATOR = " > ";

export function toCategoryFacetPath(
	superName: string,
	categoryName: string
): string {
	return `${superName}${CATEGORY_PATH_SEPARATOR}${categoryName}`;
}

export function toShopAllHref(superSlug: string): string {
	return toCategoryHref({ superSlug, categorySlug: SHOP_ALL_SLUG });
}

export function toCategoryHref({
	superSlug,
	categorySlug
}: CategoryPath): string {
	return categorySlug
		? `/shop/${superSlug}/${categorySlug}`
		: `/shop/${superSlug}`;
}
